<template>
    <modal name="crud-show" height="auto" width="900" :lazy="true" :scrollable="true" :clickToClose="false">
        <CloseModal :close="closeModal" />
        <div class="modalbox">
            <div class="modalbox-content">
                <div class="table-responsive">
                    <table class="table table-hover">
                        <thead>
                        <tr>
                            <th>Chave</th>
                            <th>Valor</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(valor, chave) in editingItem">
                            <td>{{ chave }}</td>
                            <td>{{ valor }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="modal-footer-bar">
            <CButton variant="outline" color="secondary" @click="closeModal">
                Fechar
            </CButton>
        </div>
    </modal>
</template>

<script>
  import CloseModal from "../../components/CloseModal";

  export default {
    name: "EditForm",
    props: [
      'editingItem',
    ],
    components: {
      CloseModal,
    },
    methods: {
      closeModal() {
        this.$modal.hide('crud-show');
      }
    }
  }
</script>

<style scoped>
.modal-footer-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid #e9ecef;
  background: #fff;
}
</style>